import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import logo from '@/images/themes/blue/logo.svg'
import { translate } from '@/i18n'
import { useProject } from '@/hooks/useProject'
import { useGlobalStore } from '@/stores/globalStore'
import { useMapStore } from '@/stores/mapStore'
import { useTree } from '@/api/hooks/useTree'
import { layerChangeEvent } from '@/components/layout/AppBar/search/SearchItem'

type BrandLogoProps = {
  clickable?: boolean
  height?: number
  className?: string
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  clickable = false,
  height = 38,
  className,
}) => {
  const navigate = useNavigate()
  const { workspaceId, projectId } = useProject()
  const { layers } = useTree()
  const setSeat = useGlobalStore((state) => state.setSeat)
  const setSeatEmployee = useGlobalStore((state) => state.setSeatEmployee)
  const setZoomSeat = useMapStore((state) => state.setZoomSeat)
  const setSelector = useGlobalStore((state) => state.setSelector)
  const setActiveLayer = useGlobalStore((state) => state.setActiveLayer)

  const handleClick = (e: React.MouseEvent) => {
    if (!clickable) return
    e.preventDefault()

    setSeat(null)
    setSeatEmployee(null)
    setZoomSeat(null)
    setSelector(null)

    if (layers?.layer) {
      const initialLayerId = Number(layers.layer.id)
      document.dispatchEvent(layerChangeEvent(initialLayerId))
      setActiveLayer(initialLayerId)
    }

    if (workspaceId && projectId) {
      navigate(`/project/${workspaceId}/${projectId}`)
    } else {
      navigate('/')
    }
  }

  const alt = translate('brand-name')

  if (clickable) {
    return (
      <LogoLink
        href="#"
        className={className}
        onClick={handleClick}
      >
        <LogoImage
          src={logo}
          alt={alt}
          $height={height}
        />
      </LogoLink>
    )
  }

  return (
    <LogoImage
      src={logo}
      alt={alt}
      $height={height}
      className={className}
    />
  )
}

const LogoLink = styled.a`
  cursor: pointer;
  outline: none;
  text-decoration: none;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

const LogoImage = styled.img<{ $height: number }>`
  height: ${({ $height }) => $height}px;
  width: auto;
  flex-shrink: 0;
  display: block;
`
